import React from 'react';
import styles from './restorePasswordAfterLeakForm.module.css';

import { Title } from '../Title';
import { Description } from '../Description';
import { Content } from '../Content';
import { EmailButton } from '../EmailButton';

interface Props {
  email: string;
}

export const RestorePasswordAfterLeakForm: React.FC<Props> = ({ email }) => (
  <>
    <Title>Пора обновить пароль</Title>
    <Description className={styles.description}>
      Это нужно делать периодически в целях безопасности. На вашу почту{' '}
      <span className={styles.email}>{email}</span> отправлено письмо, перейдите
      по ссылке из письма и установите пароль.
    </Description>
    <Description className={styles.description}>
      Если вы его не получили,
      <br />
      проверьте папку «Спам»
    </Description>
    <Content>
      <EmailButton email={email} />
    </Content>
  </>
);
